
import { Component, Prop } from "vue-property-decorator";
import AppModal from "@/modules/shared/components/AppModal.vue";
import AppButton from "@/modules/shared/components/AppButton.vue";
import AppDialog from "@/modules/shared/components/AppDialog.vue";

export type AppConfirmModalProps = {
  title: string;
  message?: string;
};

@Component({
  components: {
    AppButton,
    AppDialog,
  },
})
export default class AppConfirmModal extends AppModal {
  @Prop({
    required: true,
  })
  public readonly title!: string;

  @Prop({
    default: "",
  })
  public readonly message!: string;
}
